import "./Logo.css";
import "./LogoResponsive.css";

import logo from "../../assets/images/logo/Standout-white.png";
import CustomAnchor from "../../shared/Anchor/CustomAnchor";

function Logo() {
  return (
    <CustomAnchor path="/" classname="business-logo">
      <img
        src={logo}
        alt="Standout Fresh Produce Logo"
        onContextMenu={(e) => e.preventDefault()}
      />
    </CustomAnchor>
  );
}

export default Logo;
